import React, { useEffect, useState } from 'react'
import { Col, Row, Form } from "antd";
import RadioUC from "../../../components/Form/RadioUC";


const Criminal = ({ props }) => {
  const [option, setOption] = useState('')
  const { form, isReadOnly } = props

  const isLawsuit = [
    { title: 'ไม่เคย', value: false, index: 1, },
    { title: 'เคย', value: true, index: 2, }
  ]

  const onChangeLawsuit = (e) => {
    form.setFieldsValue({
      isLawsuit: e.target.value
    })
    setOption(e.target.value)
    console.log('isLawsuitValue ===', e.target.value);
  }


  return (
    <>
      <div className="content-block p-3">
        <div className="block-title">ประวัติดำเนินคดี/ประวัติอาชญากรรม (คดีจะถึงที่สุดหรือไม่ก็ตาม)</div>
        <Row>
          <Col>
            <div>ข้าพเจ้าเคยมีประวัติการถูกดำเนินคดีมาก่อนหรือไม่</div>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <RadioUC
              disabled={isReadOnly}
              required={true}
              showLabel={false}
              label={'ประวัติดำเนินคดี'}
              direction={'horizontal'}
              children={isLawsuit}
              name={"isLawsuit"}
              handleChange={onChangeLawsuit}
              value={form.getFieldValue('isLawsuit')}
            />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default Criminal;
